/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TenantPosConfigs } from '../../models/tenant-pos-configs';

export interface TenantsTenantIdDefaultConfigsGet$Params {
  tenantId: string;
}

export function tenantsTenantIdDefaultConfigsGet(http: HttpClient, rootUrl: string, params: TenantsTenantIdDefaultConfigsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<TenantPosConfigs>> {
  const rb = new RequestBuilder(rootUrl, tenantsTenantIdDefaultConfigsGet.PATH, 'get');
  if (params) {
    rb.path('tenantId', params.tenantId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TenantPosConfigs>;
    })
  );
}

tenantsTenantIdDefaultConfigsGet.PATH = '/tenants/{tenantId}/default-configs';
